export default __webpack_public_path__ + "static/010-87dee3004f6878fcd7ae0862d24f6b4e.jpg";